module.exports = __webpack_public_path__ + "img/k3-2.f753d0a0.png";